module.exports = __webpack_public_path__ + "files/ad26cc83c0ff84ac3afc867f58848783.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Bold.ttf
// module id = 803
// module chunks = 60